import { PERMISSION_GROUPS } from './permissions';

/* ─────────── Сравнение прав двух ролей (АД-15, раздел 6.24) ─────────── */

export interface RoleCompareRow {
  code: string;
  title: string;
  /** Есть ли право у первой и у второй роли */
  a: boolean;
  b: boolean;
}

export interface RoleCompareGroup {
  module: string;
  title: string;
  /** Только права, которые есть хотя бы у одной из ролей */
  rows: RoleCompareRow[];
}

export interface RoleCompareResult {
  groups: RoleCompareGroup[];
  onlyA: number;
  onlyB: number;
  both: number;
}

/** Сравнивает наборы прав двух ролей по группам из списка прав портала. Неизвестные коды игнорируются. */
export function compareRolePermissions(a: readonly string[], b: readonly string[]): RoleCompareResult {
  const setA = new Set(a);
  const setB = new Set(b);
  let onlyA = 0;
  let onlyB = 0;
  let both = 0;
  const groups: RoleCompareGroup[] = [];
  for (const g of PERMISSION_GROUPS) {
    const rows: RoleCompareRow[] = [];
    for (const p of g.permissions) {
      const inA = setA.has(p.code);
      const inB = setB.has(p.code);
      if (!inA && !inB) continue;
      if (inA && inB) both += 1;
      else if (inA) onlyA += 1;
      else onlyB += 1;
      rows.push({ code: p.code, title: p.title, a: inA, b: inB });
    }
    if (rows.length) groups.push({ module: g.module, title: g.title, rows });
  }
  return { groups, onlyA, onlyB, both };
}
